// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__NTCrF","tableHeader":"styles_tableHeader__Dj0sG","tableCell":"styles_tableCell__Vi3qW"};